import React, { useState } from 'react';
import WorkoutHistory from './WorkoutHistory';
import CardComponent from './CardComponent';
import { motion, AnimatePresence } from 'framer-motion';
import './Workout.css';

function Workout({
  started,
  drawCard,
  resetWorkout,
  progress,
  deck,
  deckType,
  setDeckType,
  totalDecksCompleted,
  milestoneMessage,
  showHistory,
  setShowHistory,
  isMobile,
  currentCard,
  isFlipped,
  showBack,
  fontSize,
  buttonPadding,
  startWorkout,
  onCompleteWorkout,
}) {
  const [showCelebration, setShowCelebration] = useState(false);

  const handleComplete = () => {
    setShowCelebration(true);
    onCompleteWorkout();
    setTimeout(() => {
      setShowCelebration(false);
      resetWorkout();
    }, 4000);
  };

  const isDeckEmpty = deck.length === 0 && started;

  if (showCelebration) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        padding: '40px',
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '20px' }}>🏆</div>
        <h1 style={{
          fontFamily: 'Bangers, sans-serif',
          fontSize: 'clamp(2rem, 6vw, 3.5rem)',
          letterSpacing: '2px',
          marginBottom: '16px',
          color: '#FFD700',
        }}>
          DECK COMPLETE!
        </h1>
        <p style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
          You stayed on the GRIND! 💪
        </p>
        {milestoneMessage && (
          <p style={{
            fontSize: '1.3rem',
            color: '#FFD700',
            marginTop: '16px',
            fontWeight: 'bold',
          }}>
            {milestoneMessage}
          </p>
        )}
        <p style={{ color: '#888', marginTop: '20px' }}>
          Total Decks Completed: {totalDecksCompleted}
        </p>
        <p style={{ color: '#666', marginTop: '10px', fontSize: '0.9rem' }}>
          Returning to home in a moment...
        </p>
      </div>
    );
  }

  return (
    <div className="grind-workout-background">
      <div className="grind-content-frame">
        <h1 className="workout-title">🔥 Grind Cards Workout</h1>
        <p className="deck-total">Total Decks Completed: {totalDecksCompleted}</p>

        {milestoneMessage && !showCelebration && (
          <div className="milestone-banner" style={{ fontSize }}>
            {milestoneMessage}
          </div>
        )}

        {!started && (
          <>
            <label htmlFor="deckType" className="deck-label">Choose Deck:</label>
            <select
              id="deckType"
              className="deck-select"
              value={deckType}
              onChange={(e) => setDeckType(e.target.value)}
            >
              <option value="full">Full Deck (54 cards)</option>
              <option value="half">Half Deck (26 cards)</option>
            </select>

            <button className="grind-button" onClick={startWorkout}>
              Start Workout
            </button>

            <button
              className="grind-button secondary"
              onClick={() => setShowHistory(!showHistory)}
            >
              {showHistory ? 'Hide History' : 'See Grind Card History'}
            </button>

            {showHistory && <WorkoutHistory />}
          </>
        )}

        {started && (
          <>
            {!isDeckEmpty && (
              <button
                className="grind-button"
                onClick={drawCard}
              >
                Draw Next Card
              </button>
            )}

            <button
              className="grind-button secondary"
              onClick={resetWorkout}
            >
              Abandon Workout
            </button>

            <div className="progress-section">
              <p className="progress-text">
                Progress: {progress}%<br />
                {deck.length} card{deck.length !== 1 && 's'} remaining
              </p>
              <div className="progress-bar-container">
                <div
                  className="progress-bar-fill"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>

            <AnimatePresence mode="wait">
              {currentCard && (
                <motion.div
                  key={currentCard?.id || deck.length}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -30 }}
                  transition={{ duration: 0.4 }}
                  style={{ marginTop: '30px' }}
                >
                  <CardComponent
                    card={currentCard}
                    flipped={isFlipped}
                    showBack={showBack}
                    isMobile={isMobile}
                  />
                </motion.div>
              )}
            </AnimatePresence>

            {isDeckEmpty && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                style={{ marginTop: '30px', textAlign: 'center' }}
              >
                <p style={{
                  color: '#fff',
                  fontSize: '1.2rem',
                  marginBottom: '16px',
                  fontFamily: 'Bangers, sans-serif',
                  letterSpacing: '1px',
                }}>
                  Last exercise done? Tap to claim your victory! 👇
                </p>
                <button
                  className="grind-button"
                  onClick={handleComplete}
                  style={{
                    backgroundColor: '#FFD700',
                    color: '#000',
                    fontSize: '1.2rem',
                    padding: '16px 32px',
                    fontWeight: 'bold',
                  }}
                >
                  ✅ I Did It! Complete Workout
                </button>
              </motion.div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Workout;